module.exports = __webpack_public_path__ + "img/WHITE_LION_PROMO.23265eb8.jpg";